// Query for general form data
export const FORM_QUERY = `
    query ($instId: String, $locId: String, $source: String, $originalSource: String, $userkey: String, $sessionid: String) {
    formData(userkey: $userkey, sessionid: $sessionid, loc_id: $locId, inst_id: $instId, source: $source, original_source: $originalSource) {
        instId
        locId
        verticalId
        title
        subtitle
        successTitle:success_title
        successSubTitle:success_subtitle
        successDescription:success_description
        redirect_url
        redirect_newtab
        requiresGDPRCompliance
        lastCompletedStep
        currentVisitorType
        largeFormImage:large_form_image
        steps {
          stepId
          fields {
              label
              fieldId
              inputType
              disabled
              required
              errorMessage
              show_if
              constrain_by
              sortOrder
              defaultValue
              placeholder              
              list {
                 value
                 label
              }
          }
        }
        completedFields
      }
    }
`;

// WelcomeHeader QUERY
export const WELCOME_HEADER_QUERY = `
  query () {
    formData() {
      title
      subtitle
    }
  }
`;

// Query for schools based on query string
// Used for school select

export const SCHOOL_QUERY = `
query ($queryString: String, $visitorType:String) {
  schools(queryString: $queryString, visitorType:$visitorType) {
    schools {
      code
      name
      city
      state
    }
  }
}

`;

// Query for majors based on query string
// Used for major select

export const MAJORS_QUERY = `
query ($searchTerm: String, $locId:String!) {
  majors(searchTerm: $searchTerm, locId: $locId) {
    majorid
    title
  }
}

`;
